import { gql } from '@apollo/client';

export type ProviderRegisterL3CityResponse = {
  providerLandingPageDataByL3City: {
    id: string;
    l3Id: string;
    l3Name: string;
    cityName: string;
    requestCountSinceLastWeek: number;
    l2Id: string;
    seo?: {
      metaTitle: string;
      metaDescription: string;
    };
  };
};

export const providerRegisterL3CityQuery = gql`
  query ProviderRegisterL3City($l3slug: String!, $citySlug: String!) {
    providerLandingPageDataByL3City(l3Slug: $l3slug, citySlug: $citySlug) {
      id
      l3Id
      cityName
      l2Id
      l3Name
      requestCountSinceLastWeek
      seo {
        metaTitle
        metaDescription
      }
    }
  }
`;
